var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99005 0.550755L10.1958 0.55073L14.9029 5.23042L14.9029 14.7414C14.9029 15.6802 14.1418 16.4414 13.2029 16.4414H3.99004C3.05115 16.4414 2.29004 15.6802 2.29004 14.7414L2.29005 2.25075C2.29005 1.31187 3.05117 0.550759 3.99005 0.550755ZM5.05653 9.61741L5.05655 13.7466C5.05655 14.0228 5.2804 14.2466 5.55655 14.2466C5.83269 14.2466 6.05655 14.0228 6.05655 13.7466L6.05653 9.61741C6.05653 9.34127 5.83267 9.11741 5.55653 9.11741C5.28039 9.11741 5.05653 9.34127 5.05653 9.61741ZM8.1043 13.7495L8.10396 8.03344C8.10394 7.7573 8.32778 7.53343 8.60393 7.53341C8.88007 7.5334 9.10394 7.75724 9.10396 8.03338L9.1043 13.7494C9.10431 14.0256 8.88047 14.2495 8.60433 14.2495C8.32819 14.2495 8.10431 14.0256 8.1043 13.7495ZM12.1523 5.60983C12.1523 5.33369 11.9284 5.10983 11.6523 5.10983C11.3761 5.10983 11.1523 5.33369 11.1523 5.60983L11.1523 13.7519C11.1523 14.0281 11.3761 14.2519 11.6523 14.2519C11.9284 14.2519 12.1523 14.0281 12.1523 13.7519L12.1523 5.60983Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ba42a9dd796b07ce27a128527b31ebb5.svg";
export { ForwardRef as ReactComponent };